import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Dialog from '../../components/Dialog'
import Politica from '../../components/TermosCondicoes/Politica'
import CondicoesGerais from '../../components/TermosCondicoes/CondicoesGerais'
import Adesao from '../../components/TermosCondicoes/Adesao'
import * as actions from '../../store/modules/cerc/actions'
import { cercDeleteAllPayments } from '../../store/modules/cerc/actions'

// import Politica from '../../components/TermosCondicoes/Politica'
import { Container, OptOut, Terms } from './styles'
import { useDispatch, useSelector } from 'react-redux'
import { StoreState } from '../../store'
const Termos: React.FC = () => {
    const { verificationC, cnpj_cpf } = useSelector(
        (state: StoreState) => state.auth.user
    )
    const dispatch = useDispatch()

    const [isTermsOpen, setIsTermsOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [Termo, setTermo] = useState<React.ReactElement | React.ReactNode>()
    function handleClick(
        element: React.ReactElement | React.ReactNode,
        title: string
    ) {
        setIsTermsOpen(true)
        setTitle(title)
        setTermo(element)
    }
    const handleOptOut = (e: React.FormEvent) => {
        // disparar um evento de optOut passando o id do optIn
        dispatch(
            actions.cerqRequestOptOut({
                cnpj_cpf: cnpj_cpf,
            })
        )
        dispatch(cercDeleteAllPayments())
    }

    return (
        <Container>
            <h2>Nossos termos</h2>
            <Terms>
                <li>
                    <button
                        onClick={() =>
                            handleClick(
                                <Politica />,
                                'Política de Privacidade e Proteção de Dados'
                            )
                        }
                    >
                        Clique aqui
                    </button>{' '}
                    para ler a Politica de Privacidade e Proteção de Dados
                </li>
                <li>
                    <button
                        onClick={() =>
                            handleClick(
                                <CondicoesGerais />,
                                'Contrato de Prestacão de Serviço e Licença de Uso de Software'
                            )
                        }
                    >
                        Clique aqui
                    </button>{' '}
                    para ler o Contrato de Prestacão de Serviço e Lincença de
                    Uso de Software
                </li>
                <li>
                    <button
                        onClick={() =>
                            handleClick(
                                <Adesao />,
                                'Termo de Adesão ao Contrato de Prestação de Serviço e Licença de Uso de Software'
                            )
                        }
                    >
                        Clique aqui
                    </button>{' '}
                    para ler o Termo de Adesão ao Contrato de Prestação de
                    Serviço e Licença de Uso de Software
                </li>
            </Terms>

            <OptOut>
                {verificationC && (
                    <span>
                        Não deseja mais compartilhar sua agenda conosco?{' '}
                        <button type="button" onClick={handleOptOut}>
                            Cancelar
                        </button>
                    </span>
                )}
            </OptOut>

            <Dialog
                isTermsOpen={isTermsOpen}
                setIsTermsOpen={setIsTermsOpen}
                title={title}
            >
                {Termo}
            </Dialog>
        </Container>
    )
}

export default Termos
